import { render, staticRenderFns } from "./ItemOutput.vue?vue&type=template&id=64de5e52&scoped=true&"
import script from "./ItemOutput.vue?vue&type=script&lang=js&"
export * from "./ItemOutput.vue?vue&type=script&lang=js&"
import style0 from "./ItemOutput.vue?vue&type=style&index=0&id=64de5e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64de5e52",
  null
  
)

export default component.exports